<template>
  <div id="contenedor-main-documentos-relacionados-obra">
      <documentos-relacionados
      :idReferencia="idObra"
      moduloOrigen="planeacion"
      :datos="getObra">
      </documentos-relacionados>
  </div>
</template>

<script>
import OBRA from '@/graphql/querys/administracion/planeacion/obra.gql';
import DocumentosRelacionados from '@/views/administracion/documentosrelacionados/Main.vue';

export default {
  name: 'DocumentosRelacionadosObraMain',
  components: {
    DocumentosRelacionados,
  },
  data() {
    return {
      idObra: this.$route.params.idObra,
    };
  },
  apollo: {
    obra: {
      query: OBRA,
      variables() {
        return {
          id: this.idObra,
        };
      },
    },
  },
  computed: {
    getObra() {
      if (!this.obra) return {};
      return this.obra;
    },
  },

};
</script>

<style>

</style>
